module.exports = __webpack_public_path__ + "static/media/tyre-yellow-four5.e575cd61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-four5.png
// module id = 361
// module chunks = 0